import * as SentryAngular from '@sentry/angular';
import * as Sentry from '@sentry/capacitor';
import { ErrorHandler, Provider } from '@angular/core';
import { Router } from '@angular/router';

import packageJson from '../package.json';
import { environment } from './environments/environment';

export const initSentry = () => {
    const sentryDSN = environment.sentryDsn;
    if (sentryDSN && packageJson) {
        Sentry.init(
            {
                dsn: environment.sentryDsn,
                environment: environment.environment,
                release: packageJson.version,
                integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
                // Performance Monitoring
                tracesSampleRate: 1.0, //  Capture 100% of the transactions
                // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
                tracePropagationTargets: [],
                // Session Replay
                replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
                replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
            },
            SentryAngular.init
        );
    }
};

export const provideSentry = (): Provider[] => {
    return [
        {
            provide: ErrorHandler,
            useValue: SentryAngular.createErrorHandler()
        },
        {
            provide: SentryAngular.TraceService,
            deps: [Router]
        }
    ];
};
